import React, { useMemo } from 'react';
import Modal from '@components/common/Modal';
import { CUSTOM_MESSAGES, LABEL } from '../../../veriables';
import style from '../OthersPopUpScreen/otherPopup.module.scss';
import cn from 'classnames';
import { TouchableButton, TouchableCross } from '@components/common/Touchable';

const NewCheckModalAnyEmployee = props => {
  // Props Destructuring
  const {
    checkModelOpen,
    serverAppTheme,
    setNewCheckModalAnyEmployee,
    newCheckModalAnyEmployee,
    setIsOpenCheck,
    handleNewCheck,
    setCheckModelOpen,
  } = props;

  const hideNewCheck =
    props.deviceInfo?.deviceGroup !== null &&
    props.deviceInfo.deviceGroup?.serverAppSettings
      ?.suppressMultipleChecksOnTable;

  // Methods

  const popupStyles = useMemo(() => {
    const modal = {
      background: serverAppTheme ? serverAppTheme.popUp_bg : '#2F2F2F',
      border: serverAppTheme ? serverAppTheme.popupBorder : '1px solid #626262',
      borderRadius: '16px',
      boxShadow: serverAppTheme?.popUp_box_shadow,
      width: '486px',
    };
    const icon = {
      color: serverAppTheme ? serverAppTheme?.primary_text : 'white',
    };
    const newcheck = {
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font,
    };
    const gotocheck = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
    };
    const cross = {
      top: '0.5rem',
      right: '0.5rem',
    };
    return { modal, icon, newcheck, gotocheck, cross };
  }, [serverAppTheme]);

  // HTML CSS CODE
  return (
    <Modal
      isOpen={checkModelOpen}
      isModalCenter
      noBackground
      customClass2="h-100 w-100 p-3 d-flex justify-content-center align-items-center my-0"
      customClass="h-100 w-100"
      style={popupStyles.modal}
    >
      <div
        className="col-12 px-0 pb-2 pt-3 justify-content-center align-items-center position-relative text-center"
        style={popupStyles.icon}
      >
        {/* 1. cross */}
        <div className="row px-0 mx-0 pb-3">
          <div className="col-12 px-0 fs_18 fw-700 text-center d-flex align-items-center justify-content-center">
            Are You Sure ?
          </div>
          <div className="fs-18 position-absolute" style={popupStyles.cross}>
            <TouchableCross
              fill={serverAppTheme?.iconcolor}
              role="presentation"
              onClick={e => {
                e.preventDefault();
                setNewCheckModalAnyEmployee({ isOpen: false });
              }}
            />
          </div>
        </div>
        {/* 2. Message */}
        <div className="col-12 fs_14 fw-400 text-center pb-2">
          {(newCheckModalAnyEmployee?.employeeName ||
            newCheckModalAnyEmployee?.lastName ||
            newCheckModalAnyEmployee?.externalId) ??
            'null'}{' '}
          {CUSTOM_MESSAGES().OPEN_TABLE_CHECK_DIFF_EMPLOYEE}
        </div>
        {/* 3. buttons */}
        <div className="col-12 w-100 row mx-0 py-2 px-0 justify-content-center align-items-center text-center p-3">
          {!hideNewCheck && (
            <div className="col-6 pl-0 pr-1">
              <TouchableButton
                className={cn(style.Unselected_menu_btn, 'w-100 btn44 rounded')}
                style={popupStyles.newcheck}
                type="button"
                onClick={event => {
                  event.preventDefault();
                  setCheckModelOpen(false);
                  handleNewCheck();
                }}
              >
                <div className="fs_20 fw-600">{LABEL().NEW_CHECK}</div>
              </TouchableButton>
            </div>
          )}
          <div className="col-6 pr-0 pl-1">
            <TouchableButton
              className={cn(
                style.secondary_btn_color,
                'w-100 btn44 border-0 rounded'
              )}
              style={popupStyles.gotocheck}
              type="button"
              onClick={e => {
                e.preventDefault();
                setNewCheckModalAnyEmployee({ isOpen: false });
                setIsOpenCheck(true);
              }}
            >
              <div className="fs_20 fw-600">{LABEL().SELECT_ANOTHER_TABLE}</div>
            </TouchableButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(NewCheckModalAnyEmployee);
